module.exports = __webpack_public_path__ + "img/081-school-1.cad14618.png";